import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { modalClose, modalOpen } from '../../../../layout/redux/layoutActions'
import { Button, IcoAdd, IcoPaste, IcoUpload, Input, InputFile, Modal, validacaoForm, verificaValidacao } from '../../../../components'
import { history, numberAleatori } from '../../../../helpers'
import { criarEmpresa, editarEmpresa, putListMeuProjetoTab, setListMeuProjetoTab, registraNaoReceberPopups  } from '../../redux/meusProjetosActions'
import { PopoverCentralAjuda } from '../../../../components/popovercentralajuda/popovercentralajuda'
import { modalAlertaInfo, modalAlertaClean, setRecebePopupCriaEmpresa  } from '../../../../layout/redux/layoutActions'
import './add.scss';

export default ({ data }) => {
  const dispatch = useDispatch()
  const { idProjetos, idPasso } = useParams()
  const { sistema, statusModal } = useSelector(state => state.layoutState)
  const { meuProjeto } = useSelector(state => state.meusProjetosState)
  const nls = require(`../../nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)
  const nlsContexto = require(`../../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const idarray = [120];
  const idarray1 = [121];

  const [erro, setErro] = useState({})
  const [form, setForm] = useState({})
  const [infomodal, setInfomodal] = useState({ selects: {} })
  const [novaHashtag, setNovaHashtag] = useState('')
  
  // Estados para controle de hashtags na edição
  const [hashtagsExistentes, setHashtagsExistentes] = useState([])
  const [hashtagsRemovidas, setHashtagsRemovidas] = useState([])
  const [hashtagsAdicionadas, setHashtagsAdicionadas] = useState([])

  useEffect(() => {
    let formInit = { 
      nomeEmpresa: '', 
      logo: '',
      hashtags: [] // Para criação, é um array vazio de strings
    }
    listRS.forEach(e => {
      formInit[e.id] = '';
    })
    
    // Se estiver editando, carrega as hashtags existentes
    if (data?.empresaId) {
      setHashtagsExistentes(data.hashtags || [])
      setHashtagsRemovidas([])
      setHashtagsAdicionadas([])
      // Para edição, o form.hashtags não é usado para mostrar as hashtags, então podemos deixar vazio
      setForm({ ...formInit, ...data, hashtags: [] })
    } else {
      // Para criação, limpa os estados de edição e seta o form
      setHashtagsExistentes([])
      setHashtagsRemovidas([])
      setHashtagsAdicionadas([])
      
      // Se data existe, usamos, mas garantimos que hashtags seja array de strings
      if (data) {
        let hashtagsFromData = [];
        if (data.hashtags) {
          // Se data.hashtags é um array de objetos, mapeamos para array de strings
          if (data.hashtags.length > 0 && typeof data.hashtags[0] === 'object') {
            hashtagsFromData = data.hashtags.map(h => h.hashtag || h);
          } else {
            hashtagsFromData = data.hashtags;
          }
        }
        setForm({ ...formInit, ...data, hashtags: hashtagsFromData })
      } else {
        setForm(formInit)
      }
    }
  }, [data])

  useEffect(() => {
    if (statusModal === 'criarEmpresaMeuProjeto') {
      setErro({});
    }
  }, [statusModal]);

  const listRS = [
    { id: 'urlFacebookEmpresa', label: 'Facebook', ph: `https://www.facebook.com/${nls.empresa}` },
    { id: 'urlInstagramEmpresa', label: 'Instagram', ph: `https://www.instagram.com/${nls.empresa}` },
    { id: 'urlTwitterEmpresa', label: 'Twitter', ph: `https://www.twitter.com/${nls.empresa}` },
    { id: 'urlYoutubeEmpresa', label: 'Youtube', ph: `https://www.youtube.com/@${nls.empresa}` },
    { id: 'urlTiktokEmpresa', label: 'Tiktok', ph: `https://www.tiktok.com/@${nls.empresa}` }
  ];

  const formRequired = {
    nomeEmpresa: ''
  }

  const handleChange = e => {
    setForm({ ...form, [e.name]: e.value })
  }

  const handleChangeFile = e => {
    setForm({ ...form, [e.name]: e.files })
  }

  // Função para adicionar uma nova hashtag
  const adicionarHashtag = () => {
    //if (!novaHashtag.trim()) return;
    const hashtagLimpa = (novaHashtag || '').trim().slice(0, 50);
    if (!hashtagLimpa) return;

    // Calcula o total de hashtags
    const totalHashtags = data?.empresaId 
      ? (hashtagsExistentes.length + hashtagsAdicionadas.length)
      : (form.hashtags?.length || 0);

    // Verifica se já atingiu o máximo
    if (totalHashtags >= 5) {
      setErro({ ...erro, novaHashtag: nls.configurar?.maxHashtags });
      return;
    }

    // Verifica se a hashtag já existe
    let hashtagExiste = false;
    
    if (data?.empresaId) {
      // Para edição: verifica em existentes e adicionadas
      hashtagExiste = 
        hashtagsExistentes.some(h => h.hashtag.toLowerCase() === novaHashtag.toLowerCase()) ||
        hashtagsAdicionadas.some(h => h.toLowerCase() === novaHashtag.toLowerCase());
    } else {
      // Para criação: verifica no form
      hashtagExiste = form.hashtags?.some(hashtag => {
        const hashtagText = typeof hashtag === 'string' ? hashtag : hashtag.hashtag;
        return hashtagText.toLowerCase() === novaHashtag.toLowerCase();
      });
    }

    if (hashtagExiste) {
      setErro({ ...erro, novaHashtag: nls.configurar?.hashtagExiste });
      return;
    }

    // Limpa o erro e adiciona a hashtag
    setErro({ ...erro, novaHashtag: '' });

    if (data?.empresaId) {
      // Para edição: adiciona às hashtagsAdicionadas
      //setHashtagsAdicionadas([...hashtagsAdicionadas, novaHashtag.trim()]);
      setHashtagsAdicionadas([...hashtagsAdicionadas, hashtagLimpa]);
    } else {
      // Para criação: adiciona ao form
      setForm({ 
        ...form, 
        //hashtags: [...(form.hashtags || []), novaHashtag.trim()]
        hashtags: [...(form.hashtags || []), hashtagLimpa] 
      });
    }
    setNovaHashtag('');
  };

  // Função para remover uma hashtag existente (em edição)
  const removerHashtagExistente = (hashtag) => {
    // Adiciona à lista de removidas
    setHashtagsRemovidas([...hashtagsRemovidas, hashtag]);
  };

  // Função para remover uma hashtag adicionada (em edição)
  const removerHashtagAdicionada = (index) => {
    const novasHashtags = hashtagsAdicionadas.filter((_, i) => i !== index);
    setHashtagsAdicionadas(novasHashtags);
  };

  // Função para remover hashtag na criação
  const removerHashtagCriacao = (index) => {
    const novasHashtags = form.hashtags?.filter((_, i) => i !== index) || [];
    setForm({ ...form, hashtags: novasHashtags });
  };

  const handlerCriar = (e) => {
    delete e.actions;
    delete e.checkboxCustom;

    // Prepara as hashtags para envio
    let hashtagsParaEnviar = [];

    if (data?.empresaId) {
      // Para edição: monta array de objetos com ação
      const paraAdicionar = hashtagsAdicionadas.map(hashtag => ({
        hashtag,
        acao: 'adicionar'
      }));
      
      const paraRemover = hashtagsRemovidas.map(hashtag => ({
        hashtag,
        acao: 'remover'
      }));
      
      hashtagsParaEnviar = [...paraAdicionar, ...paraRemover];
    } else {
      // Para criação: array simples de strings
      hashtagsParaEnviar = e.hashtags || [];
    }

    // Fecha o modal de entrada de dados
    handleCloseModal();

    if (data?.empresaId) {
      // Caso seja para editar a empresa, executa diretamente
      dispatch(editarEmpresa({ 
        ...e, 
        projetoId: idProjetos, 
        nlsPopup,
        hashtags: hashtagsParaEnviar 
      }));
    } else {
      // Caso seja para criar a empresa, exibe o modal de confirmação
      dispatch(
        modalAlertaInfo({
          ...nlsPopup[13],
          show: true,
          btnAction: () => {
            // Executa a criação após a confirmação
            dispatch(criarEmpresa({ 
              ...e, 
              projetoId: idProjetos, 
              nlsPopup,
              hashtags: hashtagsParaEnviar 
            }));

            // Limpa o modal de confirmação
            dispatch(modalAlertaClean());

            const temRedeSocial =
              !!e.urlFacebookEmpresa ||
              !!e.urlInstagramEmpresa ||
              !!e.urlTwitterEmpresa ||
              !!e.urlYoutubeEmpresa ||
              !!e.urlTiktokEmpresa;

            const temHashtag = (hashtagsParaEnviar?.length || 0) > 0;

            //Info depois de criar
            //if (sistema?.login?.recebePopupCriaEmpresa && temRedeSocial) {
            if (sistema?.login?.recebePopupCriaEmpresa && (temRedeSocial || temHashtag)) {
              dispatch(
                modalAlertaInfo({
                  ...nlsPopup[118],
                  show: true,
                  btnAction: async () => {
                    try {
                      // chama API para não receber mais esse popup
                      dispatch(registraNaoReceberPopups("NaoReceberCriaEmpresa"));
                    } finally {
                      // atualiza reducer local para não reabrir
                      dispatch(setRecebePopupCriaEmpresa(false));
                      // fecha popup
                      dispatch(modalAlertaClean());
                    }
                  },
                })
              );
            }
          },
        })
      );
    }
  };

  const handleCloseModal = () => {
    dispatch(modalClose())
  }
  
  const handleColar = e => {
    navigator.clipboard.readText().then((clipText) => {
      setForm({ ...form, [e]: clipText })
    });
  }

  // Calcula o total de hashtags para o contador
  const totalHashtags = data?.empresaId 
    ? (hashtagsExistentes.length + hashtagsAdicionadas.length)
    : (form.hashtags?.length || 0);

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {data?.empresaId
            ? nls.configurar?.editEmpresaTitle
            : nls.configurar?.addEmpresaTitle}
          <PopoverCentralAjuda 
            nlsContexto={nlsContexto} 
            idarray={data?.empresaId ? idarray1 : idarray} 
          />
        </div>
      }
      size='large'
      open={statusModal === 'criarEmpresaMeuProjeto' ? true : false}
      close={() => dispatch(modalClose())}
      closeText={nls.criarProjeto?.btnFechar}
      actions={<>
        {data?.empresaId && (
          <Button
            color='default'
            onClick={() => handleCloseModal()}
          >{nls.configurar?.btnCancelar}</Button>
        )}
        <Button
          color='primary'
          onClick={() => {
            // Validação dos campos obrigatórios
            const valid = validacaoForm({ formValues: form, formRequired });
            setErro(valid);
            const verify = verificaValidacao(valid);

            if (!verify.value) {
              return;
            }
            
            handlerCriar(form);
          }}
        >{nls.configurar?.btnFinalizarSalvar}</Button>
      </>}
    >
      <div className='modal-meuProjeto-empresas-add'>
        <h5>{nls.configurar?.subTitleDetalhes}</h5>
        <div>
          <Input
            name='nomeEmpresa'
            label={nls.configurar?.formNome}
            value={form?.nomeEmpresa}
            placeholder={nls.configurar?.formNomePHEmpresa}
            action={(e) => handleChange(e)}
            required={{
              erro,
              message: nls.mensagem.obrigatorio,
              pattern: formRequired.nomeEmpresa
            }}
          />
        </div>

        {/* Área de Hashtags */}
        <h5>{nls.configurar?.subTitleHashtags}</h5>
        <div className='hashtag-area'>
          <div className='hashtag-input-group'>
            <Input
              className='hashtag-input'
              name='novaHashtag'
              label={nls.configurar?.novaHashtagLabel}
              value={novaHashtag}
              placeholder={nls.configurar?.novaHashtagPH}
              action={(e) => {
                //setNovaHashtag(e.value);
                setNovaHashtag((e.value || '').slice(0, 50));
                // Limpa o erro quando o usuário digitar
                if (erro.novaHashtag) {
                  setErro({ ...erro, novaHashtag: '' });
                }
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  adicionarHashtag();
                }
              }}
              required={{
                erro,
                message: erro.novaHashtag,
                pattern: false
              }}
            />
            <Button
              
              color='primary'
              onClick={adicionarHashtag}
              disabled={totalHashtags >= 5}
            >
              {nls.configurar?.btnAdicionarHashtag}
            </Button>
          </div>
          
          {/* Contador de hashtags */}
          <div className='hashtag-counter'>
            {totalHashtags}/5 {nls.configurar?.hashtagsMax}
          </div>
          
          {/* Container com borda para as hashtags */}
          {(hashtagsExistentes.length > 0 || hashtagsAdicionadas.length > 0 || form.hashtags?.length > 0) && (
            <div className='hashtags-container'>
              <div className='hashtags-list'>
                {/* Para edição: mostra hashtags existentes e adicionadas */}
                {data?.empresaId ? (
                  <>
                    {/* Hashtags existentes */}
                    {hashtagsExistentes.map((h, index) => {
                      const foiRemovida = hashtagsRemovidas.includes(h.hashtag);
                                            
                      
                      const className = `hashtag-item ${foiRemovida || h.status === 'aremover' ? 'hashtag-removida' : ''}`;
                      
                      return (
                        <div key={`existente-${index}`} className={className}>

                          <span title={h.status === 'aremover' ? nls.hashtagRemocaoTooltip : undefined}>
                            {h.hashtag}
                          </span>

                          {h.status === 'ativo' && !foiRemovida && (
                            <button
                              type='button'
                              className='hashtag-remove'
                              onClick={() => removerHashtagExistente(h.hashtag)}
                            >
                              ×
                            </button>
                          )}
                        </div>
                      );
                    })}
                    
                    {/* Hashtags adicionadas pelo usuário */}
                    {hashtagsAdicionadas.map((hashtag, index) => (
                      <div key={`adicionada-${index}`} className='hashtag-item'>
                        <span>{hashtag}</span>
                        <button
                          type='button'
                          className='hashtag-remove'
                          onClick={() => removerHashtagAdicionada(index)}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </>
                ) : (
                  /* Para criação: mostra apenas as hashtags do form */
                  form.hashtags?.map((hashtag, index) => {
                    // 🔥 CORREÇÃO: Garante que sempre seja string
                    const hashtagText = typeof hashtag === 'string' ? hashtag : (hashtag.hashtag || hashtag);
                    return (
                      <div key={index} className='hashtag-item'>
                        <span>{hashtagText}</span>
                        <button
                          type='button'
                          className='hashtag-remove'
                          onClick={() => removerHashtagCriacao(index)}
                        >
                          ×
                        </button>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          )}
        </div>

        <h5>{nls.configurar?.subTitleRedesSociais}</h5>
        <div className='colflex col2'>
          {listRS.map(e => (
            <Input
              key={e.id}
              name={e.id}
              label={e.label}
              value={form?.[e.id]}
              placeholder={e.ph}
              action={(e) => handleChange(e)}
              disabled={data?.empresaId && data?.[e.id]}
              right={<>
                <span className='btn-colar' onClick={() => !(data?.empresaId && data)?.[e.id] ? handleColar(e.id) : null}><IcoPaste /> {nls.configurar?.btnColar}</span>
              </>}
            />
          ))}
        </div>
      </div>
    </Modal>
  )
}
